export default __webpack_public_path__ + "static/cta-button-f77ce031bb475448f41731c3beae4bf1.png";